import { functions } from './firebase';
import { getDocumentsAsArray } from './firestore';

const paths = {
  kinderSystemsReports: () => `kinderSystemsReports`,
  kinderSystemsReport: (id) => `kinderSystemsReports/${id}`,
};

export const getkinderSystemsReports = async ({ organizationID, locationID, limit = 5 }) => {
  try {
    if (!locationID) return;
    return getDocumentsAsArray({
      path: paths.kinderSystemsReports(),
      conditions: [
        { field: 'organizationID', operation: '==', value: organizationID },
        { field: 'locationID', operation: '==', value: locationID },
      ],
      orderBy: [{ field: 'dateOfSubmission', direction: 'desc' }],
      limit,
    });
  } catch (error: any) {
    console.log(error);
    throw new Error(error?.message || 'Error in while fetching Kinder Systems Report.');
  }
};

export const submitKSReport = async (data) => {
  return functions().httpsCallable('callables-integration-submitKSReport')(data);
};

export const uploadAttendanceToKinderSystems = async (attendanceData) => {
  const { data } = await functions().httpsCallable('callables-kinderSystems-transferAttendanceToKinderSystems')(
    attendanceData
  );
  return data;
};

export const getChildListFromKinderSystems = async (ksData) => {
  const { data } = await functions().httpsCallable('callables-kinderSystems-getChildListFromKinderSystems')(ksData);
  return data;
};

export const matchStudentsWithKinderSystems = async (data) => {
  const { data: response } = await functions().httpsCallable('callables-kinderSystems-matchStudentsWithKinderSystems')(
    data
  );
  return response;
};
